{
  "titles": {
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save"
  }
}
